import Vue from 'vue'
import Vuex from 'vuex'

import loader from './modules/loader'
import authentication from './modules/authentication'
import customers from './modules/customers'
import products from './modules/products'
import countries from './modules/countries'
import designer from './modules/designer'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    loader,
    auth: authentication,
    customers,
    products,
    countries,
    designer
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js